import { useEffect, useState } from 'react';
import { Calendar, Users, Clock, Sparkles } from 'lucide-react';
import { supabase } from '../../../../lib/supabase';

export function LandingPage() {
  const [userName, setUserName] = useState<string>('');

  useEffect(() => {
    const getUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user?.email && window.location.pathname !== '/auth/login') {
        setUserName(user.email.split('@')[0]);
      } else {
        setUserName('');
      }
    };
    getUser();
    
    const { data: authListener } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'SIGNED_OUT') {
        setUserName('');
      }
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);

  const features = [
    {
      icon: <Calendar className="w-8 h-8 text-vincer-500" />,
      title: "Smart Calendar Integration",
      description: "Seamlessly connect with Google Calendar to manage your mentorship availability."
    },
    {
      icon: <Users className="w-8 h-8 text-vincer-500" />,
      title: "Mentee Matching",
      description: "Get matched with mentees based on your expertise and availability."
    },
    {
      icon: <Clock className="w-8 h-8 text-vincer-500" />,
      title: "Flexible Scheduling",
      description: "Set your availability and let mentees book time slots that work for you."
    }
  ];

  return (
    <div className="max-w-6xl mx-auto">
      <div className="bg-white border rounded-xl p-6 mb-16 flex items-center gap-6">
        <div className="bg-amber-50 p-4 rounded-lg">
          <Sparkles className="w-8 h-8 text-vincer-500" />
        </div>
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            Welcome back{userName ? `, ${userName}` : ''}! 👋
          </h2>
          <p className="text-gray-600">
            Ready to make an impact? View your upcoming mentorship sessions and manage your availability.
          </p>
        </div>
      </div>

      <div className="text-center mb-16">
        <h1 className="text-5xl font-bold mb-6 bg-gradient-to-r from-vincer-500 to-vincer-400 bg-clip-text text-transparent">
          VINCER Mentor Dashboard
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
          Share your knowledge and experience with the next generation of professionals.
          Make a difference in someone's career journey.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        {features.map((feature, index) => (
          <div key={index} className="bg-white p-8 rounded-xl shadow-sm border hover:shadow-md transition-shadow">
            <div className="bg-amber-50 w-16 h-16 rounded-lg flex items-center justify-center mb-6">
              {feature.icon}
            </div>
            <h3 className="text-xl font-semibold mb-3">{feature.title}</h3>
            <p className="text-gray-600">{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}